class MathJaxLoader {
    constructor(config, article) {
        this.mathJaxConfiguration = config.config;
        this.mathJaxCdnLoader = config.src;
        this.mathJaxVersion = config.version;
        this.article = article;
    }

    loadMathJax() {
        if (this.article.querySelector('math, [role="math"]')) {
            window.MathJax = JSON.parse(JSON.stringify(this.mathJaxConfiguration));

            const mathjaxSource = document.createElement('script');
            mathjaxSource.type = 'text/javascript';
            mathjaxSource.src = this.selfHostedPath() || this.mathJaxCdnLoader;
            mathjaxSource.async = true;
            document.head.appendChild(mathjaxSource);
        }
    }

    selfHostedPath() {
        try {
            let releasedAssetsPath = this.releasedAssetsPath();
            if (releasedAssetsPath && FilesFingerprint.mathjax) {
                return `${releasedAssetsPath}public/mathjax-${FilesFingerprint.mathjax}/tex-mml-chtml.js`;
            }
        } catch (e) {
            console.error('Error accessing FilesFingerprint', e);
        }
        return null;
    }

    releasedAssetsPath() {
        const resourcePath = Array.prototype.slice
            .call(document.querySelectorAll('link'))
            .map(node => node.href)
            .filter(href => href.indexOf('releasedAssets') > 0)[0];

        if (resourcePath) {
            return `${resourcePath.split('releasedAssets')[0]}releasedAssets/`;
        } else {
            return null;
        }
    }
}

module.exports = MathJaxLoader;
